export default {
  'newIndex':'home_page',
  'register':'registion_page',
  'login':'log_in_page',
}



// WEBPACK FOOTER //
// ./src/utils/route_page_id.js